import React, { useEffect, useState, useMemo } from "react";
import "./UsersRegister.scss";
import { motion, AnimatePresence } from "framer-motion";

import {
  registerNas,
  fetchNas,
  updateRadius,
  deleteRadius,
  fetchGroup,
  registerGroup,
  updateGroup,
  deleteGroup,
} from "../services/apiRadius";

export default function UsersRegister() {
  const [users, setUsers] = useState([]);
  const [group, setGroup] = useState([]);

  const [openModal, setOpenModal] = useState(false);
  const [openModalGroup, setOpenModalGroup] = useState(false);

  const [editingUser, setEditingUser] = useState(null);
  const [editingGroup, setEditingGroup] = useState(null);

  const [page, setPage] = useState(1);
  const [currentTab, setCurrentTab] = useState(0);
  const [search, setSearch] = useState("");

  const [toast, setToast] = useState(null);

  const rowsPerPage = 10;

  const [form, setForm] = useState({
    nasname: "",
    shortname: "",
    type: "",
    ports: "",
    secret: "",
    server: "",
    community: "",
    description: "",
    nasusername: "",
    naspassword: "",
  });

  const [formGroup, setFormGroup] = useState({
    groupname: "",
    attribute: "Mikrotik-Rate-Limit",
    op: ":=",
    value: "",
    price: "",
    target: "",
  });

  // 🔥 TOAST
  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  };

  // 🔥 LOAD DATA
  useEffect(() => {
    async function load() {
      try {
        const data = await fetchNas();
        const dataGroup = await fetchGroup();
        setUsers(data);
        setGroup(dataGroup);
      } catch (err) {
        console.error(err);
      }
    }
    load();
  }, []);

  // 🔥 FILTER OPTIMISÉ
  const filtered = useMemo(() => {
    return users.filter((v) =>
      v.nasname.toLowerCase().includes(search.toLowerCase())
    );
  }, [users, search]);

  const filteredGroup = useMemo(() => {
    return group.filter((v) =>
      v.groupname.toLowerCase().includes(search.toLowerCase())
    );
  }, [group, search]);

  const displayed = filtered.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const displayed_group = filteredGroup.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  // 🔥 SUBMIT NAS (CREATE + UPDATE)
  async function handleSubmit(e) {
    e.preventDefault();

    try {
      if (editingUser) {
        await updateRadius(editingUser.id, form);
        setUsers((prev) =>
          prev.map((u) => (u.id === editingUser.id ? { ...u, ...form } : u))
        );
        showToast("✅ Modifié avec succès");
      } else {
        const data = await registerNas(form);
        setUsers((prev) => [...prev, data]);
        showToast("✅ Ajouté avec succès");
      }

      setOpenModal(false);
      setEditingUser(null);
      resetForm();
    } catch (err) {
      console.error(err);
      showToast("❌ Erreur", "error");
    }
  }

  // 🔥 SUBMIT GROUP
  async function handleSubmitGroup(e) {
    e.preventDefault();

    try {
      if (editingGroup) {
        await updateGroup(editingGroup.id, formGroup);
        setGroup((prev) =>
          prev.map((g) =>
            g.id === editingGroup.id ? { ...g, ...formGroup } : g
          )
        );
        showToast("✅ Modifié avec succès");
      } else {
        const data = await registerGroup(formGroup);
        setGroup((prev) => [...prev, data]);
        showToast("✅ Ajouté avec succès");
      }

      setOpenModalGroup(false);
      setEditingGroup(null);
      resetFormGroup();
    } catch (err) {
      console.error(err);
      showToast("❌ Erreur", "error");
    }
  }

  // 🔥 DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer ?")) return;

    await deleteRadius(id);
    setUsers((prev) => prev.filter((u) => u.id !== id));
    showToast("🗑️ Supprimé");
  };

  const handleDeleteGroup = async (id) => {
    if (!window.confirm("Supprimer ?")) return;

    await deleteGroup(id);
    setGroup((prev) => prev.filter((g) => g.id !== id));
    showToast("🗑️ Supprimé");
  };

  // 🔥 RESET
  const resetForm = () => {
    setForm({
      nasname: "",
      shortname: "",
      type: "",
      ports: "",
      secret: "",
      server: "",
      community: "",
      description: "",
      nasusername: "",
      naspassword: "",
    });
  };

  const resetFormGroup = () => {
    setFormGroup({
      groupname: "",
      attribute: "Mikrotik-Rate-Limit",
      op: ":=",
      value: "",
      price: "",
      target: "",
    });
  };

  return (
    <div className="page-content">
      <div className="users-header">
        <h2>Gestion de Radius</h2>
      </div>

      {/* 🔥 TOAST */}
      {toast && (
        <div className={`toast ${toast.type}`}>
          {toast.message}
        </div>
      )}

      {/* TABS */}
      <div className="tabs">
        <button className={`tab ${currentTab === 0 ? "active" : ""}`} onClick={() => setCurrentTab(0)}>
          Microtik
        </button>
        <button className={`tab ${currentTab === 1 ? "active" : ""}`} onClick={() => setCurrentTab(1)}>
          Bouquet (Forfait)
        </button>
      </div>

      {/* ================= NAS ================= */}
      {currentTab === 0 && (
        <div className="section-left">
          <div className="nas-header">
            <div className="filter-bar">
              <input
                type="text"
                placeholder="Filter microtik..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            <button
              onClick={() => {
                setEditingUser(null);
                resetForm();
                setOpenModal(true);
              }}
              className="btn-add-radius"
            >
              ➕ Ajouter Microtik
            </button>
          </div>

          <div className="vc-card">
            <table className="vc-table video-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>nasname</th>
                  <th>shortname</th>
                  <th>Type</th>
                  <th>Ports</th>
                  <th>Server</th>
                  <th>Community</th>
                  <th>Description</th>
                  <th>Routeur user</th>
                  <th>Routeur password</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {displayed.map((user) => (
                  <tr key={user.id}>
                    <td>{user.id}</td>
                    <td>{user.nasname}</td>
                    <td>{user.shortname}</td>
                    <td>{user.type}</td>
                    <td>{user.ports}</td>
                    <td>{user.server}</td>
                    <td>{user.community}</td>
                    <td>{user.description}</td>
                    <td>{user.nasusername}</td>
                    <td>{user.naspassword}</td> 
                    <td>
                      <button
                        className="vc-btn"
                        onClick={() => {
                          setEditingUser(user);
                          setForm(user);
                          setOpenModal(true);
                        }}
                      >
                        ⚙️ Modifier
                      </button>

                      <button
                        className="vc-btn danger"
                        onClick={() => handleDelete(user.id)}
                      >
                        🗑️
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ================= GROUP ================= */}
      {currentTab === 1 && (
        <div className="section-right">
          <div className="nas-header">
            <div className="filter-bar">
              <input
                type="text"
                placeholder="Filter forfait..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            <button
              onClick={() => {
                setEditingGroup(null);
                resetFormGroup();
                setOpenModalGroup(true);
              }}
              className="btn-add-radius"
            >
              ➕ Ajouter Un forfait
            </button>
          </div>

          <div className="vc-card">
            <table className="vc-table video-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>groupname</th>
                  <th>value</th>
                  <th>price</th>
                  <th>target</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {displayed_group.map((g) => (
                  <tr key={g.id}>
                    <td>{g.id}</td>
                    <td>{g.groupname}</td>
                    <td>{g.value}</td>
                    <td>{g.price}</td>
                    <td>{g.target}</td>
                    <td>
                      <button
                        className="vc-btn"
                        onClick={() => {
                          setEditingGroup(g);
                          setFormGroup(g);
                          setOpenModalGroup(true);
                        }}
                      >
                        ⚙️ Modifier
                      </button>

                      <button
                        className="vc-btn danger"
                        onClick={() => handleDeleteGroup(g.id)}
                      >
                        🗑️
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}



      
      {/* MODAL */}
      <AnimatePresence>
        {openModal && (
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="modal"
              initial={{ scale: 0.9, y: 50 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.9, y: 50 }}
            >
              <h3>Nouveau Microtik</h3>
                <button
                className="vc-modal-close"
                onClick={() => setOpenModal(false)}
              >
                ✕
              </button>

              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  placeholder="nasname complet"
                  value={form.nasname}
                  required
                  onChange={(e) =>
                    setForm({ ...form, nasname: e.target.value })
                  }
                />

                <input
                  type="text"
                  placeholder="shortname"
                  value={form.shortname}
                  required
                  onChange={(e) =>
                    setForm({ ...form, shortname: e.target.value })
                  }
                />

                <input
                  type="text"
                  placeholder="Type"
                  value={form.type}
                  required
                  onChange={(e) =>
                    setForm({ ...form, type: e.target.value })
                  }
                />
                <input
                  type="text"
                  placeholder="Ports"
                  value={form.ports}
                  required
                  onChange={(e) =>
                    setForm({ ...form, ports: e.target.value })
                  }
                />
                <input
                  type="text"
                  placeholder="Code secret"
                  value={form.secret}
                  required
                  onChange={(e) =>
                    setForm({ ...form, secret: e.target.value })
                  }
                />
                <input
                  type="text"
                  placeholder="Server"
                  value={form.server}
                  required
                  onChange={(e) =>
                    setForm({ ...form, server: e.target.value })
                  }
                />
                <input
                  type="text"
                  placeholder="Communiy"
                  value={form.community}
                  required
                  onChange={(e) =>
                    setForm({ ...form, community: e.target.value })
                  }
                />
                <input
                  type="text"
                  placeholder="Description"
                  value={form.description}
                  required
                  onChange={(e) =>
                    setForm({ ...form, description: e.target.value })
                  }
                />
                <input
                  type="text"
                  placeholder="Routeur username"
                  value={form.nasusername}
                  required
                  onChange={(e) =>
                    setForm({ ...form, nasusername: e.target.value })
                  }
                />
                
                <input
                  type="text"
                  placeholder="Routeur password"
                  value={form.naspassword}
                  required
                  onChange={(e) =>
                    setForm({ ...form, naspassword: e.target.value })
                  }
                />


                <div className="modal-actions">
                  <button
                    type="button"
                    className="badge admin"
                    onClick={() => setOpenModal(false)}
                  >
                    Annuler
                  </button>
                  <button type="submit" className="badge acteur">
                    Enregistrer
                  </button>
                </div>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      
      {/* MODAL */}
      <AnimatePresence>
        {openModalGroup && (
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="modal"
              initial={{ scale: 0.9, y: 50 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.9, y: 50 }}
            >
              <h3>Nouveau Bouquet (Forfait)</h3>
                <button
                className="vc-modal-close"
                onClick={() => setOpenModalGroup(false)}
              >
                ✕
              </button>

              <form onSubmit={handleSubmitGroup}>
                <input
                  type="text"
                  placeholder="groupname"
                  value={formGroup.groupname}
                  required
                  onChange={(e) =>
                    setFormGroup({ ...formGroup, groupname: e.target.value })
                  }
                />

                <input
                  type="hidden"
                  placeholder="attribute"
                  value="Mikrotik-Rate-Limit"
                  required
                  onChange={(e) =>
                    setFormGroup({ ...formGroup, attribute: e.target.value })
                  }
                />

                <input
                  type="hidden"
                  placeholder="op"
                  value={":="}
                  required
                  onChange={(e) =>
                    setFormGroup({ ...formGroup, ":=": e.target.value })
                  }
                />
                <input
                  type="text"
                  placeholder="value"
                  value={formGroup.value}
                  required
                  onChange={(e) =>
                    setFormGroup({ ...formGroup, value: e.target.value })
                  }
                />
                <input
                  type="text"
                  placeholder="price"
                  value={formGroup.price}
                  required
                  onChange={(e) =>
                    setFormGroup({ ...formGroup, price: e.target.value })
                  }
                />
                <input
                  type="text"
                  placeholder="target (nombre de jours)"
                  value={formGroup.target}
                  required
                  onChange={(e) =>
                    setFormGroup({ ...formGroup, target: e.target.value })
                  }
                />


                <div className="modal-actions">
                  <button
                    type="button"
                    className="badge admin"
                    onClick={() => setOpenModal(false)}
                  >
                    Annuler
                  </button>
                  <button type="submit" className="badge acteur">
                    Enregistrer
                  </button>
                </div>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>

  );
}